import React from 'react'

export default function Tagscard(props) {
  return (
    <a href='/'>{props.tagsTxt}</a>
  )
}
